export const MenuItems = [
    {
        title : "Home",
        url: "/",
        cName : "nav-links",
        icon : "fa fa-home"
    },
    {
        title : "About Us",
        url: "/about",
        cName : "nav-links",
        icon : "fa fa-info-circle"
    },
    {
        title : "Services",
        url: "/services",
        cName : "nav-links",
        icon : "fa fa-industry"
    },
    {
        title : "Projects",
        url: "/projects",
        cName : "nav-links",
        icon : "fa fa-folder-open"
    },
    {
        title : "Products",
        url: "/products",
        cName : "nav-links",
        icon : "fa fa-link"
    },
    {
        title : "Contact",
        url: "/contact",
        cName : "nav-links",
        icon : "fa fa-comments"
    },
    {
        title : "Call Now",
        url: "/",
        cName : "nav-links-mobile", 
    }
]